import axios from "axios";
import { securePostAPI } from "./apiService";
import { apiConfig } from "../../config";
import store from "../store";
const API_BASE_URL = apiConfig.apiformbaseurl;

export async function fetchFormsForUser(userId) {
  try {
    const batchCourseData = await securePostAPI({ userId }, "mysa/student/getBatchCourse");
    const { batchId, courseId } = batchCourseData || {};
    if (!batchId && !courseId) {
      return [];
    }
    

    const formsResponse = await securePostAPI(
      { batchId,courseId },
      "mysa/student/forms/byBatchCourse"
    );
    return formsResponse|| [];
  } catch (err) {
    console.error("Error fetching forms for user:", err);
    return [];
  }
}

export async function fetchFormDetail(formId) {
  const res = await axios.get(`${API_BASE_URL}/forms/${formId}`);
  return res.data;
}

export async function submitFormAnswers(formId, payload, userId) {
  const access = await checkUserFormAccess(userId, formId);
  if (!(access && access.message === "User can access this form")) {
    throw { error: "You are not allowed to submit this form." };
  }
  const res = await axios.post(`${API_BASE_URL}/forms/${formId}/submit`, payload);
  return res.data;
}

export async function checkUserFormAccess(userId, formId) {
  try {
    console.log('store.getters.apiBaseUrl', store.getters.apiBaseUrl);
    const res = await axios.post(store.getters.apiBaseUrl+'feedbackForms/checkUserForm', {
      userId,
      formId,
    });
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      throw err.response.data;
    }
    throw { error: "Unknown error" };
  }
}